import apiClient from './apiClient';

export interface Area {
  id: number;
  name: string;
  description?: string;
  countryIds: number[];
  isActive: boolean;
}

export const areaService = {
  getAll: () => 
    apiClient.get('/areas'),

  create: (area: Omit<Area, 'id'>) =>
    apiClient.post('/areas', area),

  update: (id: number, area: Partial<Area>) =>
    apiClient.put(`/areas/${id}`, area),

  delete: (id: number) =>
    apiClient.delete(`/areas/${id}`),

  addCountry: (areaId: number, countryId: number) =>
    apiClient.post(`/areas/${areaId}/countries/${countryId}`),

  removeCountry: (areaId: number, countryId: number) =>
    apiClient.delete(`/areas/${areaId}/countries/${countryId}`)
};